export enum ResponseTypeCheck {
  JSON = 'JSON',
  TEXT = 'TEXT',
  ARRAY_BUFFER = 'arraybuffer',
  CONT_JSON = 'APP_JSON',
  CONT_MULT = 'APP_MULT',
}
